import { usePermission } from '@juvare/contact-management/ui/hooks';
import React from 'react';
import { Route, Routes } from 'react-router';
import { EditMission, NewMission } from '../mission';
import { MissionDetailsPage } from '../mission-details';
import { MissionListPage } from '../mission-list';
import { DuplicateShift, EditShift, NewShift } from '../shift';
export const MissionsPanel = () => {
    const { requireAnySystemPermission } = usePermission();
    const allowMissionChange = requireAnySystemPermission('manage-missions', 'manage-all-admin-missions');
    return (React.createElement(Routes, null,
        React.createElement(Route, { path: '/', element: React.createElement(MissionListPage, null) }),
        allowMissionChange && (React.createElement(React.Fragment, null,
            React.createElement(Route, { path: '/new', element: React.createElement(NewMission, null) }),
            React.createElement(Route, { path: '/:missionId/new-shift/*', element: React.createElement(NewShift, null) }),
            React.createElement(Route, { path: '/:missionId/edit-shift/:shiftId', element: React.createElement(EditShift, null) }),
            React.createElement(Route, { path: '/:missionId/duplicate-shift/:shiftId', element: React.createElement(DuplicateShift, null) }),
            React.createElement(Route, { path: '/:missionId/edit', element: React.createElement(EditMission, null) }))),
        React.createElement(Route, { path: '/:missionId/*', element: React.createElement(MissionDetailsPage, null) })));
};
